export default __webpack_public_path__ + "static/assets/confetti.8e0efb38.svg";